<template>
  <canvas ref="myChart" id="myChart" width="250px"></canvas>
</template>

<script>
import * as Colors from './color'

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    total: {
      get() {
        return this.$store.state.statistics.stat.data.total
      }
    },
  },
  watch: {
    data(n, o) {
      if (n) {

        let sortable = []
        Object.keys(this.data).forEach((key,index) => {
          sortable.push([key, this.data[key]])
        })

        sortable.sort(function(a, b) {
            return b[1] - a[1];
        });

        sortable.forEach(item => {
          let key = item[0]
          let value = item[1]

          this.$chrt.data.labels.push(key)

          this.$chrt.data.datasets.forEach((dataset) => {
            dataset.data.push(value)
          });
        })

        // Object.keys(this.data).forEach((key,index) => {
        //   this.$chrt.data.labels.push(key)

        //   this.$chrt.data.datasets.forEach((dataset) => {
        //     dataset.data.push(Math.ceil((this.data[key] / this.total) * 100))
        //   });
        // });


        this.$chrt.update()
      }
    }
  },
  mounted() {
    this.$chrt = new Chart(this.$refs.myChart, {
      type: 'horizontalBar',
      data: {
        labels: [ ],
        datasets: [{
          label: 'Region',
          data: [ ],
          backgroundColor: Colors.getColorsAsString(0.5) ,
          borderColor:  Colors.getColorsAsString(),
        }]
      },
      options: {
        legend: false,
        maintainAspectRatio: false,
        responsive: true,
        tooltips: {
            enabled: true,
            mode: 'single',
            displayColors: false,
            xPadding: 5,
            yPadding: 5,
            titleSpacing: 0,
            callbacks: {
                title: function(tooltipItems, data) {},
                label: function(tooltipItems, data) {
                  let label = data.labels[tooltipItems.index]
                  let value = data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index]
                  return `${label}: ${value}`
                  return
                }
            }
        },
        scales: {
          xAxes: [{
            display:true,
            ticks: {
              beginAtZero: true,
              steps: 20,
              stepValue: 20,
              callback: function(value, index, values) {
                return value
              }
            }
          }],
          yAxes: [{
            display:true,
            ticks: {
                    // Include a dollar sign in the ticks
              callback: function(value, index, values) {
                return value.replace('Region ', '')
              },
              // mirror: true,
              // padding: -10
            }
          }]
        },
      }
    })
  }
}
</script>

<style>

</style>
